"use client";
import { jsx as c } from "react/jsx-runtime";
import { memo as m } from "react";
import a from "../components/Icon/SvgIcon.js";
const o = (h) => /* @__PURE__ */ c(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...h,
    children: /* @__PURE__ */ c(
      "path",
      {
        fill: "currentColor",
        d: "m22.7 12.41-1.97-3.79s-.05-.09-.09-.13c-.31-.34-.75-.54-1.21-.54h-3.52V6.87c0-1.03-.84-1.87-1.87-1.87h-9c-1.03 0-1.87.84-1.87 1.87v4.84h1.24V6.87c0-.35.28-.63.63-.63h9c.35 0 .63.28.63.63v9.39H9.86a2.37 2.37 0 0 0-2.29-1.75c-1.1 0-2.01.75-2.28 1.75h-.25c-.35 0-.63-.28-.63-.63v-.71h.02c.25 0 .45-.2.45-.45s-.2-.45-.45-.45H1.45c-.25 0-.45.2-.45.45s.2.45.45.45h1.72v.71c0 1.03.84 1.87 1.87 1.87h.25a2.37 2.37 0 0 0 2.29 1.76c1.1 0 2.02-.75 2.29-1.76h6.68a2.37 2.37 0 0 0 2.29 1.76c1.1 0 2.02-.75 2.29-1.76h.25c.9 0 1.62-.73 1.62-1.63v-2.24c0-.42-.1-.84-.3-1.22M7.57 18.02a1.14 1.14 0 1 1-.001-2.279 1.14 1.14 0 0 1 .001 2.279m13.78-5.51h-2.88v-1.47h2.11zm-2.52 5.51a1.14 1.14 0 1 1-.001-2.279 1.14 1.14 0 0 1 .001 2.279m2.54-1.76h-.25a2.37 2.37 0 0 0-2.29-1.75c-1.1 0-2.01.75-2.28 1.75h-.64V9.2h3.52c.09 0 .18.03.24.09l.27.52h-2.09c-.34 0-.62.28-.62.62v2.71c0 .34.28.62.62.62h3.9v2.12c0 .21-.17.39-.38.39zM9.49 14.47a3.97 3.97 0 0 1-3.96-3.96 3.97 3.97 0 0 1 3.96-3.96 3.97 3.97 0 0 1 3.96 3.96 3.97 3.97 0 0 1-3.96 3.96m0-6.92c-1.63 0-2.96 1.33-2.96 2.96s1.33 2.96 2.96 2.96 2.96-1.33 2.96-2.96-1.33-2.96-2.96-2.96m1.6 4.96c-.09 0-.19-.04-.26-.1l-1.66-1.59a.4.4 0 0 1-.12-.27V8.21a.38.38 0 1 1 .76 0v2.18l1.54 1.48c.15.14.15.38.01.53-.07.08-.17.12-.27.12zm-6.67.65H2.11c-.25 0-.45-.2-.45-.45s.2-.45.45-.45h2.31c.25 0 .45.2.45.45s-.2.45-.45.45"
      }
    )
  }
), v = m(o);
export {
  v as TruckSameDay,
  v as default
};
